<template>
  <span>
    <a class="data-table-action"
       :title="$t('view')"
       v-b-tooltip.hover
       @click="show">
        <EyeSvg class="svg-light"/>
        <span class="action-button-mob-title">{{ $t('view') }}</span>
      </a>
    </span>
</template>

<script setup>
import EyeSvg from '@/assets/svg-vue/form/eye.svg'
import { useStore} from "vuex"
import {copyObject} from "@/extensions/prototypes/prototypes"
import {getCurrentInstance, onMounted} from "vue"

const props = defineProps({
  object: {
    type: Object
  }
})

let bvModal = null
const store = useStore()

onMounted(() => {
  bvModal = (getCurrentInstance())?.ctx?._bv__modal
})

const show = async () => {
  await store.dispatch('getPatientCanbanStatuses')
  store.commit('setPatientCanban', copyObject(props.object))
  bvModal?.show('patient-canban-modal')
}
</script>

<style scoped>
.data-table-action svg {
  width: 16px;
  height: 16px;
}
</style>
